import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../helpers"
import { Context, StudyPlanTargets, Transitions } from "../types"

export const getStudyPlansTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  entry: assign<Context>({
    loading: true
  }),
  invoke: {
    id: "getStudyPlansBySubject",
    src: "getStudyPlansBySubject",
    onDone: [
      {
        target: "#StudyPlan.study_plans_overview.get_global_settings",
        cond: (ctx, _evt) =>
          (ctx.selfRefScope.scope === "DISTRICT" ||
            ctx.selfRefScope.scope === "SCHOOL") &&
          ctx.currentTarget === StudyPlanTargets.Overview &&
          ctx.viewGlobalSettings,

        actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => ({
          studyPlansListBySubjects: evt.data.plans,
          loading: false
        }))
      },
      {
        target: "idle",
        cond: (ctx, _evt) =>
          ctx.currentTarget === StudyPlanTargets.Landing &&
          (ctx.selfRefScope.scope === "DISTRICT" ||
            ctx.selfRefScope.scope === "SCHOOL"),
        actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
          const getDefaultSubject =
            ctx.isOldNav && Object.keys(evt.data.plans)?.[0]
          return {
            studyPlansListBySubjects: evt.data.plans,
            subject: ctx.subject ?? getDefaultSubject,
            loading: false
          }
        })
      },
      {
        target:
          "#StudyPlan.study_plans_overview.get_admin_relevant_plan_info_transition",
        cond: (ctx, _evt) =>
          ctx.currentTarget === StudyPlanTargets.Overview &&
          (ctx.selfRefScope.scope === "DISTRICT" ||
            ctx.selfRefScope.scope === "SCHOOL"),
        actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
          const getDefaultSubject =
            ctx.isOldNav && Object.keys(evt.data.plans)?.[0]
          return {
            studyPlansListBySubjects: evt.data.plans,
            subject: ctx.subject ?? getDefaultSubject
          }
        })
      },
      {
        target:
          "#StudyPlan.teacher_view.get_teacher_assigned_subjects_transition",
        cond: (ctx, _evt) => ctx.selfRefScope.scope === "TEACHER",
        actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => ({
          studyPlansListBySubjects: evt.data.plans
        }))
      }
    ],
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        loading: false,
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage(
            "getCurrentPlanForEachSubjectByRefScope",
            {
              errorReason: evt.data.message
            }
          ),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
